<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="blue"
          icon="mdi-store"
          title="YTD Commissions"
          value="$34,245"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="blue"
          icon="mdi-store"
          title="YTD Premium"
          value="$45,295"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="red"
          icon="mdi-information-outline"
          title="Unreconciled Premium"
          value="$5,890"
          sub-icon="mdi-tag"
          sub-text="Last 24 Hours"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3></v-flex>
      <!-- <v-layout row wrap> -->
        <v-flex sm6 xs12 md12 lg9>
          <p>Upload bank transactions</p>
          <vue-dropzone id="drop1" :options="dropOptions" 
           ref="myVueDropzone"
          :include-styling="true"
          :useCustomSlot="true"
          @vdropzone-upload-progress="uploadProgress"
          @vdropzone-file-added="fileAdded"
          @vdropzone-sending-multiple="sendingFiles"
          @vdropzone-success-multiple="success"
          ></vue-dropzone>
        </v-flex>
      <!-- </v-layout> -->
      <v-flex md12 lg12>
         <label>File
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
      </label>
        <button v-on:click="submitFile()">Submit</button>
        <material-card
          color="blue"
          title="Commission Statements"
          text="Received commission statements"
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <!--Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Begin Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      @input="menu1 = false"
                      header-color="primary"
                      no-title
                      dark
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <!--End Date picker-->

                <!--Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date2"
                      @input="menu2 = false"
                      header-color="primary"
                      no-title
                      dark
                    ></v-date-picker>
                  </v-menu>
                </v-flex> 
                <!--End Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-btn
                    round
                    color="primary"
                    dark
                    @click="$router.push({ name: 'Commission Detail' })"
                  >Add Statement</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-data-table :headers="headers" :items="commissions">
            <template slot="headerCell" slot-scope="{ header }">
              <span v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ item.commission_upload_date }}</td>
              <td>{{ item.carrier_external_id }}</td>
              <td>{{ item.commission_date }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.is_reconciled }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import vueDropzone from "vue2-dropzone";
import _ from "lodash";
import CommissionService from "@/api-services/commission.service.js";
import FileService from "@/api-services/file.service.js";
import axios from 'axios';

export default {
  data() {
    return {
      file:"",
      commissions:[],
      attachments: [],
      tempAttachments: [],
      dropOptions: {
          // The Url Where Dropped or Selected files will be sent
        url: `http://localhost:8000/file_basic`,
        // url:"https://httpbin.org/post",
        //autoProcessQueue: false,
        method:"POST",
        maxFilesize: 2, // MB
        maxFiles: 4,
        chunking: true,
        chunkSize: 500, // Bytes
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
         // Authentication Headers like Access_Token of your application
        // headers: {
        //   Authorization: `Access Token`
        // },
        // The way you want to receive the files in the server
        paramName: function(n) {
          return "file[]";
        },
      },
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      headers: [
        {
          sortable: false,
          text: "Received Date",
          value: "receivedDate"
        },
        {
          sortable: false,
          text: "Payer",
          value: "payer"
        },
        {
          sortable: false,
          text: "Commission Date",
          value: "commissionDate"
        },
        {
          sortable: false,
          text: "Amount",
          value: "amount"
        },
        {
          sortable: false,
          text: "Reconciled",
          value: "reconciled"
        }
      ],
      items: [
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "BCBSIL",
          amount: "$35,738",
          reconciled: true
        },
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "Aetna",
          amount: "$5,738",
          reconciled: true
        },
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "UHC",
          amount: "$5,221",
          reconciled: true
        },
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "UHC",
          amount: "$21,839",
          reconciled: true
        },
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "Aetna",
          amount: "$8",
          reconciled: true
        },
        {
          receivedDate: "04/02/2019",
          commissionDate: "1/1/2019-1/31/2019",
          payer: "Aetna",
          amount: "$48",
          reconciled: true
        }
      ]
    };
  },
      created() {
    this.setColor("blue");
     this.initialize();
  },  
  components: {
    vueDropzone
  },
  computed: {},
  methods: {
    handleFileUpload(){
    this.file = this.$refs.file.files[0];
  },
  submitFile(){
    let formData = new FormData();
    formData.append('file', this.file);

    axios.post( 'localhost:8000/file_basic',
  formData,
  {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  }
).then(function(){
  console.log('SUCCESS!!');
})
.catch(function(){
  console.log('FAILURE!!');
});
},

    initialize() {
      CommissionService.getCommissionsByUser("user0001")
        .then(response => {
          var commission = response.data.commission;
          this.commissions = _.toArray(commission);
          console.log(this.commissions);
        })
        .catch(error => {
          console.log(error);
        });
    },
    
      setColor (color) {
      this.$store.state.app.color = color
    },

    //Dropzone methods
     // function called for every file dropped or selected
    fileAdded(file) {
      console.log("File Dropped => ", file);
      // Construct your file object to render in the UI
      let attachment = {};
      attachment._id = file.upload.uuid;
      attachment.title = file.name;
      attachment.type = "file";
      attachment.extension = "." + file.type.split("/")[1];
      attachment.user = JSON.parse(localStorage.getItem("user"));
      attachment.content = "File Upload by Select or Drop";
      attachment.thumb = file.dataURL;
      attachment.thumb_list = file.dataURL;
      attachment.isLoading = true;
      attachment.progress = null;
      attachment.size = file.size;
      this.tempAttachments = [...this.tempAttachments, attachment];

      //  console.log("Files sending", file);
      // FileService.create(file)
      //         .then(response => {
      //           console.log(response);
      //           if (response.status == 200) {
      //             this.$toasted.show("File uploaded successfully.", {
      //               theme: "bubble",
      //               position: "top-right",
      //               duration: 5000,
      //               onClick: (e, toastObject) => {
      //                 toastObject.goAway(0);
      //               }
      //             });
      //           }
      //         })
      //         .catch(error => {
      //           console.log(error);
      //           this.$toasted.show(error);
      //         });
    },
    // a middle layer function where you can change the XHR request properties
    sendingFiles(files, xhr, formData) {
      
      console.log("Files sending", files);

    },
    // function where we get the upload progress
    uploadProgress(file, progress, bytesSent) {
      console.log("File Upload Progress", progress);
      this.tempAttachments.map(attachment => {
        if (attachment.title === file.name) {
          attachment.progress = `${Math.floor(progress)}`;
        }
      });
    },
    // called on successful upload of a file
    success(file, response) {
      console.log("File uploaded successfully");
      console.log("Response is ->", response);
    }

  }
};
</script>
<style>
</style>

